import { useFormContext } from 'react-hook-form';

import { DetaljeringForm, DirtyFieldsType } from './types';

export const useValgfriDetaljeringContext = () => {
  return useFormContext<DetaljeringForm>();
};

export const detaljeringsstegDefault = {
  bygningsform: false,
  vegger: false,
  vinduer: false,
  gulv: false,
  lekkasjetall: false,
  solceller: false,
  takkonstruksjon: false,
  ytterdorer: false
};

export const hasUncheckedDetaljeringSteps = (data: DetaljeringForm, dirtyFields: DirtyFieldsType): boolean => {
  // Dirty fields is true if value has been changed. Check if any of the changed fields are now unchecked (false).
  return (
    (!!dirtyFields.bygningsform && !data.bygningsform) ||
    (!!dirtyFields.vegger && !data.vegger) ||
    (!!dirtyFields.vinduer && !data.vinduer) ||
    (!!dirtyFields.gulv && !data.gulv) ||
    (!!dirtyFields.lekkasjetall && !data.lekkasjetall) ||
    (!!dirtyFields.solceller && !data.solceller) ||
    (!!dirtyFields.takkonstruksjon && !data.takkonstruksjon) ||
    (!!dirtyFields.ytterdorer && !data.ytterdorer)
  );
};
